import { z } from 'zod';

export const optOutSchema = z.object({
  channel: z.string(),
  createdAt: z.string(),
  // null = manual via API/BO; 'bounce' | 'complaint' = automatico por el webhook del proveedor (RFC 0002 Fase 3)
  reason: z.enum(['bounce', 'complaint']).nullable().optional(),
});
export type OptOut = z.infer<typeof optOutSchema>;

export const optOutInputSchema = z.object({
  channel: z.string(),
});
export type OptOutInput = z.infer<typeof optOutInputSchema>;
